var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamRedBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 47,
    viewBox: "0 0 204 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97203_6626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.674805 46.0625L57.636 0.462524H215.137V46.0625H0.674805Z",
    fill: "url(#paint0_linear_97203_6626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0996 11.8625L73.247 0.462524H84.0371L69.6176 11.8625H59.0996Z",
    fill: "#F53033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 46.0625L27.6474 34.6625H38.4375L24.018 46.0625H13.5Z",
    fill: "#F53033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97203_6626",
    x1: 107.906,
    y1: 0.462524,
    x2: 107.906,
    y2: 46.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97203_6626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.35,
    height: 45.6,
    fill: "white",
    transform: "translate(0.674805 0.462524)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamRedBackground);
export default __webpack_public_path__ + "static/media/team-red-background.38038fbc9c57c2280d4b696209ab9942.svg";
export { ForwardRef as ReactComponent };